import {  Box, Grid, Paper, Typography, Button, Stack, Chip, Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";

const highlights = [
  {
    title: 'Serene surroundings',
    copy: 'Tall oaks, quiet mornings, and walking paths wrapped in soft moss.',
  },
  {
    title: 'Nature-led comforts',
    copy: 'Herbal teas, linen bedding, and spaces that invite you to breathe deeper.',
  },
];

const cards = [

  {
    title: 'Read Our Stories',
    copy: 'Stories, seasonal rituals, and nature notes from the cottage.',
    action: 'Read the blog',
    to: '/blog',
  },
 
];

const LandingPage=()=> {
  const navigate = useNavigate();
  const motto = process.env.REACT_APP_SITE_MOTTO || 'A wonderful place to refresh your mind and soul.';

  return (
    <Box sx={{ pt: { xs: 1, md: 2 }, pb: 6, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <Paper
        elevation={6}
        sx={{
          p: { xs: 3, md: 5 },
          overflow: 'hidden',
          position: 'relative',
          background: 'linear-gradient(135deg, #f5f7f2 0%, #e7efe5 50%, #f7f2e8 100%)',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            pointerEvents: 'none',
            '&::before': {
              content: '""',
              position: 'absolute',
              width: 320,
              height: 320,
              background: 'radial-gradient(circle, rgba(107,143,113,0.18) 0%, transparent 60%)',
              top: -60,
              right: -40,
              filter: 'blur(2px)',
            },
            '&::after': {
              content: '""',
              position: 'absolute',
              width: 260,
              height: 260,
              background: 'radial-gradient(circle, rgba(58,90,64,0.22) 0%, transparent 60%)',
              bottom: -40,
              left: -20,
              filter: 'blur(3px)',
            },
          }}
        />
        <Stack spacing={2} sx={{ maxWidth: 720, position: 'relative', zIndex: 1 }}>
          <Chip
            label="Welcome to Heart's Ease Cottage"
            variant="outlined"
            sx={{ alignSelf: 'flex-start', bgcolor: 'rgba(159,191,155,0.18)', borderColor: 'rgba(58,90,64,0.24)' }}
          />
          <Typography variant="h3" component="h1">
            Calm, nature-inspired stays for slow days.
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
            {motto}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ pt: 1 }}>
            <Button size="large" variant="contained" color="primary" onClick={()=>navigate('/about')}>
              Explore the cottage
            </Button>
            <Button size="large" variant="outlined" color="secondary" onClick={()=>navigate('/blog')}>
              Read the journal
            </Button>
          </Stack>
          <Divider sx={{ width: '100%', borderColor: 'rgba(31,42,28,0.08)', my: 2 }} />
          <Grid container spacing={2}>
            {highlights.map((item) => (
              <Grid item xs={12} sm={4} key={item.title}>
                <Stack spacing={0.5}>
                  <Typography variant="subtitle1" fontWeight={700}>{item.title}</Typography>
                  <Typography variant="body2" color="text.secondary">{item.copy}</Typography>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Stack>
      </Paper>

      <Grid container spacing={3}>
        {cards.map((card) => (
          <Grid item xs={12} md={4} key={card.title}>
            <Paper
              elevation={4}
              sx={{
                p: 3,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
                background: 'linear-gradient(180deg, #ffffff 0%, #f3f6f1 100%)',
              }}
            >
              <Typography variant="h5">{card.title}</Typography>
              <Typography variant="body2" color="text.secondary">{card.copy}</Typography>
              <Box sx={{ flexGrow: 1 }} />
              <Button variant="text" color="primary" onClick={()=>navigate(card.to)}>
                {card.action}
              </Button>
            </Paper>
          </Grid>
        ))}
      </Grid>

      <Paper
        elevation={4}
        sx={{
          p: { xs: 3, md: 4 },
          background: 'linear-gradient(120deg, rgba(107,143,113,0.12), rgba(220,204,170,0.16))',
          borderStyle: 'solid',
          borderWidth: 1,
          borderColor: 'rgba(58,90,64,0.18)',
        }}
      >
        <Stack spacing={1.5} alignItems={{ xs: 'flex-start', md: 'center' }} textAlign={{ xs: 'left', md: 'center' }}>
          <Typography variant="h4">“A place like no other.”</Typography>
          <Typography variant="body1" color="text.secondary">
            Thoughtfully curated spaces, nature-forward rituals, and a slower pace—so you can arrive, exhale, and feel at ease.
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}
export default LandingPage;
